import React,{useState, useEffect} from "react"
import {inmAndCondStyles} from "../../constants"
import {useAuthContext} from "../../hooks/useAuthContext"
import {getUser} from "../../api/usuario"
import {Button} from "@mui/material"
import EditProfile from "../../components/profile/EditProfile"
import Page from "../../layouts/Page"
import {useLogout} from "@/hooks/useLogout"

function Profile() {
   const [loading, setLoading] = useState(false)
   const {user} = useAuthContext()
   const [name, setName] = useState("")
   const [phone, setPhone] = useState("")
   const [role,setRole] = useState("")
   const [showEditForm, setShowEditForm] = useState(false)
   const {logout} = useLogout()

   const fetchUser = async () => {
      try {
         setLoading(true)

         const fetchedUser = await getUser(user?.email)
         setName(fetchedUser.data.user.name)
         setPhone(fetchedUser.data.user.phone)
         setRole(fetchedUser.data.user.role)
         setLoading(false)
      } catch (error) {
         console.log(error)
      }
   }

   useEffect(() => {
      fetchUser()
   }, [])

   const hideForm = () => {
      setShowEditForm(false)
   }

   return (
      <Page>
         <>
            {loading && <h2 className={inmAndCondStyles.loading}>Cargando...</h2>}
            {!loading && (
               <div className="text-center my-auto flex flex-col">
                  <h3 className="font-bold text-2xl mt-10 mb-4">
                     ¡Hola, {name}! ¡Bienvenido de vuelta!
                  </h3>
                  <p className="mb-4 text-blue">
                     Rol: {role === "admin" ? "Administrador" : "Socio"}
                  </p>
                  {!showEditForm && (
                     <Button
                        variant="contained"
                        style={{
                           color: "white",
                           maxWidth: "200px",
                           margin: "auto",
                        }}
                        onClick={() => setShowEditForm(true)}
                     >
                        Editar mis datos
                     </Button>
                  )}
                  {showEditForm && (
                     <EditProfile
                        hideForm={hideForm}
                        name={name}
                        phone={phone}
                        fetchUser={fetchUser}
                     />
                  )}
                  <button
                     onClick={logout}
                     className="px-4 py-1 bg-gray-500 text-white rounded-md mt-20 max-w-[200px] mx-auto"
                  >
                     Cerrar sesión
                  </button>
               </div>
            )}
         </>
      </Page>
   )
}

export default Profile
